<template>
    <div class="results-box">
        <h1>Balance</h1>
        <medal :medalType="label" />
        <p>The questions, information sources and environmental trends you considered spanned three primary categories: internal/typical, moderately strategic, and external/sometime unconventional. The balance of your choices across those categories can be as important as breadth. A strong mix of insights will ensure you pay attention to the new trends in the world around your business but also don’t lose sight of what’s right in front of you.</p>
        <p v-html="desc"></p>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from "vuex"
    import Medal from '@/components/Medal.vue'
    
    export default{
        name : "BalanceRibbonFeedback",
        components: {
            'medal' : Medal,
        },
        data(){
            return {
                rbn : "",
                desc : "",
                label: ""
            }
        },
        mounted(){
            this.setRibbon()
            // TODO: add text to JSON
        },
        computed : {
            ...mapGetters([
                "getScoring",
                "getBalanceResult"
            ])
        },
        methods : {
            setRibbon(){
                const balance = this.getScoring.balance.options
                const cat = this.getBalanceResult
                this.rbn = balance[ cat ].source
                this.desc = balance[ cat ].description
                this.label = cat;
            }
        }
    }
</script>